<template>

  <ValidationObserver ref="validationObserver" @submit.prevent="handleSubmit(onSubmit)" v-slot="{ handleSubmit }">


      <v-row>

        <v-col v-for="formElem in filterArray"
          :key="formElem.id"
          :lg="formElem.lg"
          :md="formElem.md"
          :sm="formElem.sm"
          :cols="formElem.xs"
          >

          <ValidationProvider :name="formElem.label"  :rules="formElem.validation ? 'required' : null" v-slot="{ errors }">    

              <custom-input v-if="formElem.type == 'text' || formElem.type == 'number' || formElem.type == 'password'"
                v-model="response[formElem.name]"
                :type="formElem.type"
                :label="formElem.label"
                :defaultValue="formElem.defaultValue"
                :ifRequired="formElem.validation"
                :errorMessage="errors"
                @input="autoSubmitHandler">
              </custom-input>

              <custom-datepicker v-if="formElem.type == 'date'"
                v-model="response[formElem.name]"
                :defaultValue="formElem.defaultValue"
                :label="formElem.label"
                :ifRequired="formElem.validation"
                :errorMessage="errors"
                @input="autoSubmitHandler"
              >
              </custom-datepicker>

              <select-menu-custom v-if="formElem.type == 'selectmenu'"
                v-model="response[formElem.name]"
                :defaultValue="formElem.defaultValue"
                :label="formElem.label"
                :name="formElem.name"
                :options="formElem.options"
                :multiple="formElem.multiple"
                :ifRequired="formElem.validation"
                :errorMessage="errors"
                @input="autoSubmitHandler"
                >
              </select-menu-custom>

              <autocomplete v-if="formElem.type == 'autocomplete'"
                v-model="response[formElem.name]"
                :defaultValue="formElem.defaultValue"
                :label="formElem.label"
                :name="formElem.name"
                :ifRequired="formElem.validation"
                :errorMessage="errors"
                :graphqlqueryProps="formElem.graphqlquery"
                :graphqlqueryStringProps="formElem.graphqlqueryString"
                :tooltipText="formElem.tooltipText"
                @input="autoSubmitHandler"
                >
              </autocomplete>
              
          </ValidationProvider>

        </v-col>

      </v-row>


      <v-row 
       no-gutters
       :justify="buttonJustify"
       v-if="!autoSubmit"
       >  
        <v-col cols="1"> 

          <v-btn
            outlined
            fab
            color="teal"
            @click="onSubmit"
          >
            <v-icon>{{buttonIcon}}</v-icon>
          </v-btn>
          
        </v-col>
      </v-row>
    
    
  </ValidationObserver>

</template>

<script>

//Import VeeValidate
import { ValidationProvider, ValidationObserver,  extend  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});


//Impoert input component
import CustomInput from './CustomInput.vue';
import CustomDatepicker from './CustomDatepicker.vue';
import SelectMenuCustom from './SelectMenuCustom.vue';
import Autocomplete from "./Autocomplete.vue"

export default {

  //Init model variables
  created () {

  },

  components: {
      CustomInput,
      CustomDatepicker,
      SelectMenuCustom,
      Autocomplete,
      "ValidationProvider": ValidationProvider,
      "ValidationObserver": ValidationObserver,

  },

  props:[
      "filterArrayProps",
      "autoSubmit",
      "buttonJustify",
      "buttonIcon"
  ],

  data: function(){

    var dataDict = {}
    this.filterArrayProps.forEach((elem) => {
      dataDict[elem.name] = elem.defaultValue
    });

    return({
       filterArray : this.filterArrayProps,
       response: dataDict
    })
  },

  methods:{
      onSubmit () {

        this.$refs.validationObserver.validate().then(success => {
            if (success) {
              const keys = Object.keys(this.response);
              var submitDict = {};
              keys.forEach((val) => {
                submitDict[val] = this.response[val]
              });
              this.$emit('submitEvent', submitDict) ;
            }
        }); 
      },

      autoSubmitHandler(){
        if(this.autoSubmit){  
           //Wait until the models are updated in the UI
            this.$nextTick(() => {
              this.onSubmit()
            });  
        }
        
      }
  }

}
</script>

<style>

</style>